export type CustomerLanguage = "en" | "hi";

const HINDI_PATH = /^\/hi(?:\/|$)/;

/**
 * Resolve the customer-facing language from a route. Shared client islands use
 * this instead of relying on every /hi caller to remember a language prop.
 */
export function customerLanguageFromPath(pathname?: string | null): CustomerLanguage {
  if (!pathname) return "en";
  const path = pathname.startsWith("http") ? new URL(pathname).pathname : pathname;
  return HINDI_PATH.test(path) ? "hi" : "en";
}

export function resolveCustomerLanguage(
  language: CustomerLanguage | undefined,
  pathname?: string | null
): CustomerLanguage {
  return language ?? customerLanguageFromPath(pathname);
}

export function normalizeCustomerLanguage(language?: string | null): CustomerLanguage {
  return language === "hi" ? "hi" : "en";
}

export function customerKundaliPath(language: CustomerLanguage): string {
  return language === "hi" ? "/hi/free-kundali" : "/free-kundali";
}

export function customerAstrologerPath(language: CustomerLanguage): string {
  return language === "hi" ? "/hi/astrologers" : "/ai-astrologer";
}
